import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ThankYouPage.scss';
const ThankYouPage = () => {
  return (
    <div className="thank-you-page">
      <div className="thank-you-container">
        <h1>ขอบคุณสำหรับคำอวยพร</h1>
        <p>คำอวยพรของคุณมีความหมายมากสำหรับเรา</p>
        <div className="button-group">
          <Link to="/" className="back-link">กลับหน้าแรก</Link>
        </div>
      </div>
    </div>
  );
};
export default ThankYouPage;